export default __webpack_public_path__ + "static/media/beeSQL_Logo_Stacked.436e1f83.png";